import axios from 'axios';
import config from '../common/config';

export default {
  /**
   * Generate PDF for a trip
   * @param {string} token - Auth token
   * @param {number|string} rideId - Ride ID
   * @param {string} style - 'itinerary' for the practical day-by-day PDF,
   *                         'brochure' for the two-page marketing document
   * @param {Object|null} photos - Brochure only: the photos picked in the photo
   *                               picker, { cover: url, stays: { stayKey: [url] } }.
   *                               Anything left out is chosen automatically.
   * @returns {Promise} - Axios response with PDF blob
   */
  generateTripPDF(token, rideId, style = 'itinerary', photos = null) {
    const body = { rideId: rideId.toString(), style };
    if (photos) {
      body.photos = photos;
    }
    return axios.post(
      `${config.config.ROOT_URL}/api/generate-trip-pdf`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        responseType: 'blob' // Important: tell axios to expect binary data
      }
    );
  },

  /**
   * Photos the brochure can use, grouped by stay, with the automatic picks
   * @param {string} token - Auth token
   * @param {number|string} rideId - Ride ID
   * @returns {Promise} - Axios response: { cover: {...}, stays: [...] }
   */
  getBrochurePhotoOptions(token, rideId) {
    return axios.get(
      `${config.config.ROOT_URL}/api/brochure-photo-options/${rideId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  }
};
